var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"an-sendmail btn",attrs:{"href":("mailto:?cc=" + _vm.cc + "&bcc=" + _vm.bcc + "&subject=" + _vm.subject + "&body=" + _vm.body)}},[_vm._v("E-Mail senden")])}
var staticRenderFns = []

export { render, staticRenderFns }